import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import React from "react";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import i18n from "../../constants/i18n";
import getDashBoardStore from "../../stores/dashboard-store";

const KhattabatCapacity = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isManualKhattabaAdmin = getCorePersonalStore().isManualKhattabaAdmin.get();
  const khattabatCapacity = getDashBoardStore().khattabatAdminCapacity.get();

  return isManualKhattabaAdmin ? (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={300}
        height={30}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => { }}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={30}
          text={i18n.get("CAPACITY")}
          isSpan={false}
          color={colors.all.limeGreen}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={10} />

        <Et3Text
          fontFamily={"BOLD"}
          fontSize={30}
          text={`${khattabatCapacity}`}
          isSpan={false}
          color={colors.all.limeGreen}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={0} left={0} right={0} bottom={30} />
    </React.Fragment>
  ) : null;
});
export default KhattabatCapacity;
